import { AddAccountRequestSchema, AddAccountResponseSchema } from './add-account.schema';
/**
 * Add Account Endpoint Contract
 * Creates a customer — the level above tenants. Super-admin only.
 */ export const addAccountContract = {
    method: 'POST',
    path: '/api/v2/admin/accounts',
    description: 'Create an account (customer)',
    requestSchema: AddAccountRequestSchema,
    responseSchema: AddAccountResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Bad Request - the company is already assigned to another account',
            401: 'Unauthorized - invalid or missing token',
            403: 'Forbidden - not a super-admin'
        }
    }
};

//# sourceMappingURL=add-account.contract.js.map